// extracted by mini-css-extract-plugin
module.exports =  {"listing":"listing__CSklN","listingAndNameCol":"listingAndNameCol__rUB2o","specInfo":"specInfo__Dqgpf","lastCol":"lastCol__gh0Oe","eCouponIcon":"eCouponIcon__ZkB7o"};